// src/disc/discItems.js
//
// Sözcük → harf eşlemesi. TEK KAYNAK (2026-08-18).
//
// Her grup 4 satırdır; her satır ["En Çok harfi", "En Az harfi"] taşır.
// "-" = hiçbir harfe puan yazmayan sözcük. Şablonda ("DISC analizi envanter
// ŞABLON.xlsx", K9/L9 satırları) böyle 25 "en çok" ve 21 "en az" sözcüğü vardır;
// bu yüzden bir kişinin harf sayımları 24'e değil, daha azına toplanır.
//
// DOĞRULANDI 2026-08-18: bu tablo şablondaki K5:K9 / L5:L9 formülleriyle
// 96 sözcüğün 96'sında birebir örtüşür.
//
// ÖNCEDEN App.js içindeydi; admin ekranı boşluk sayımlarını raporlayabilsin diye
// buraya alındı. İki yerde ayrı kopya tutulursa biri güncellenip diğeri unutulur.

const letterMapRows = [
  [["S","S"], ["I","-"], ["C","C"], ["-","D"]],
  [["I","I"], ["C","C"], ["D","D"], ["-","S"]],
  [["-","C"], ["D","D"], ["S","-"], ["I","I"]],
  [["C","-"], ["S","S"], ["-","D"], ["D","I"]],
  [["-","I"], ["C","C"], ["-","D"], ["S","S"]],
  [["D","D"], ["S","S"], ["-","I"], ["-","C"]],
  [["-","C"], ["S","-"], ["D","D"], ["I","I"]],
  [["D","-"], ["I","-"], ["-","S"], ["-","C"]],
  [["I","I"], ["S","S"], ["D","D"], ["C","-"]],
  [["D","D"], ["C","-"], ["-","I"], ["S","S"]],
  [["I","I"], ["S","S"], ["-","C"], ["D","D"]],
  [["-","I"], ["D","D"], ["C","-"], ["S","S"]],
  [["D","-"], ["I","I"], ["S","S"], ["-","C"]],
  [["C","C"], ["D","-"], ["I","I"], ["S","-"]],
  [["S","-"], ["-","-"], ["C","C"], ["-","D"]],
  [["I","-"], ["-","S"], ["-","C"], ["D","D"]],
  [["C","-"], ["S","S"], ["-","I"], ["D","D"]],
  [["I","-"], ["S","-"], ["-","C"], ["D","D"]],
  [["C","-"], ["D","D"], ["I","I"], ["S","S"]],
  [["D","D"], ["C","-"], ["-","S"], ["I","I"]],
  [["S","I"], ["-","S"], ["D","D"], ["C","C"]],
  [["I","I"], ["-","C"], ["D","D"], ["S","S"]],
  [["I","I"], ["C","-"], ["D","D"], ["-","S"]],
  [["D","D"], ["S","S"], ["I","I"], ["C","C"]],
];

export default letterMapRows;
export { letterMapRows };

/** Bir kaydın ham cevaplarından harf sayımlarını ve boşluk ("-") sayısını çıkarır. */
export function sayimlariCikar(answers) {
  const most = { D: 0, I: 0, S: 0, C: 0 };
  const least = { D: 0, I: 0, S: 0, C: 0 };
  let mostBos = 0;
  let leastBos = 0;

  (Array.isArray(answers) ? answers : []).forEach((a) => {
    const gm = letterMapRows[a.groupId - 1];
    if (!gm) return;
    const hm = gm[a.most]?.[0] ?? "-";
    const hl = gm[a.least]?.[1] ?? "-";
    if (most[hm] !== undefined) most[hm]++; else mostBos++;
    if (least[hl] !== undefined) least[hl]++; else leastBos++;
  });

  return { most, least, mostBos, leastBos, toplam: (Array.isArray(answers) ? answers.length : 0) };
}
